import React from 'react';
import { IntlShape, injectIntl } from '@kyruus/intl';
import { MlocPeriods } from '@kyruus/types';

import { LocationInfoItem } from './styles';

import {
  getCurrentDay,
  getCurrentTime,
  getProviderClinicAvailability
} from './utils';

interface ProviderClinicHoursProps {
  periods: MlocPeriods[];
  timezone?: string;
  intl: IntlShape;
}

const ProviderClinicHours = ({
  periods,
  timezone,
  intl
}: ProviderClinicHoursProps): React.ReactElement | null => {
  const presentDay = getCurrentDay('dddd', timezone);
  const presentTime = getCurrentTime(timezone);
  const hoursAvailability = getProviderClinicAvailability(
    periods,
    presentDay,
    presentTime,
    intl
  );

  if (!hoursAvailability) {
    return null;
  }

  return (
    <>
      {hoursAvailability?.map((i: string) => (
        <li key={i as string}>
          <LocationInfoItem>
            <time itemProp="openingHours">{i}</time>
          </LocationInfoItem>
        </li>
      ))}
    </>
  );
};

export default injectIntl(ProviderClinicHours);
